import React from 'react';
import { browserHistory } from 'react-router'; // Importação importante para o clique funcionar
import axios from 'axios';
import urlBase from '../../../url-base';
import { 
    FaStepBackward, FaWallet, FaCheckDouble, 
    FaSearch, FaHeadset, FaExclamationCircle, FaHistory, FaTimesCircle 
} from "react-icons/fa";

class PessoaJuridica extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countPJawaitingPayment: 0,
            countPJonActivation: 0,
            countPJactivated: 0,
            countPJinValidation: 0,
            countPJafterSales: 0,
            countPJpending: 0,
            countPJdeployed60Days: 0,
            countPJcanceled60Days: 0,
            showPanelPJ: true,
            showPJawaitingPayment: true,
            showPJonActivation: true,
            showPJactivated: true,
            showPJinValidation: true,
            showPJafterSales: true,
            showPJpending: true,
            showPJdeployed60Days: true,
            showPJcanceled60Days: true
        };
        // Cores originais preservadas
        this.colors = {
            red: 'rgba(209, 4, 36, 0.7)',
            purple: '#b778c7',
            green: 'rgba(5, 134, 15, 0.6)',
            darkCyan: 'rgba(0,139,139,0.7)',
            orange: 'rgba(245, 170, 0, 0.8)',
            dimGray: 'rgba(105,105,105, 0.7)',
            blue: 'rgba(2, 17, 199, 0.5)',
            bg: '#f8fafc'
        };        
    }

    componentDidMount() {
        this.showBox();
        this.getCountPj();
    }
    goBack() {
        window.history.back();
    }
    // Método para navegar via código (mais seguro que o <Link> nesta versão)
    handleNavigation(path) {
        if (path && path !== '#') {
            browserHistory.push(path);
        }
    }

    showBox() {
        let state = this.state;
        let type = localStorage.getItem('dental_y');

        if (type === 'REGISTER' || type === 'AFTER SALES') {
            state.showPJawaitingPayment = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        } else if (type === 'ADMIN') {
            state.showPanelPJ = false;
            state.showPJonActivation = false;
            state.showPJactivated = false;
        } else if (type === 'PJCADASTRO') {
            state.showPJawaitingPayment = false;
        }

        this.setState(state);
    }

    getCountPj() {
        const url = urlBase.loopBack + 'Companies/countByUser';
        const dataSend = { user: localStorage.getItem('dental_u') };
        axios.post(url, dataSend).then((response) => {
            this.setState({
                countPJawaitingPayment: response.data.countPJawaitingPayment || 0,
                countPJonActivation: response.data.countPJonActivation || 0,
                countPJactivated: response.data.countPJactivated || 0,
                countPJinValidation: response.data.countPJinValidation || 0,
                countPJafterSales: response.data.countPJafterSales || 0,
                countPJpending: response.data.countPJpending || 0,
                countPJdeployed60Days: response.data.countPJdeployed60Days || 0,
                countPJcanceled60Days: response.data.countPJcanceled60Days || 0
            });
        });
    }

    renderMetricCard(title, count, path, color, Icon) {
        const cardStyle = {
            display: 'flex',
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            marginBottom: '15px',
            minHeight: '85px',
            alignItems: 'center',
            border: '1px solid #e2e8f0',
            overflow: 'hidden',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            cursor: 'pointer' // Cursor de clique em todo o card
        };

        return (
            <div 
                style={cardStyle} 
                className="card-hover" 
                onClick={() => this.handleNavigation(path)}
            >
                <div style={{
                    width: '70px', height: '85px', backgroundColor: color, 
                    display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
                    WebkitFlexShrink: 0, flexShrink: 0 
                }}>
                    <Icon size={24} />
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px' }}>
                    <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#475569', lineHeight: '1.2' }}>
                        {title}
                    </span>
                    <div style={{
                        backgroundColor: '#f1f5f9', borderRadius: '50%', minWidth: '40px', height: '40px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', 
                        fontWeight: 'bold', fontSize: '18px', color: '#334155', marginLeft: '10px'
                    }}>
                        {count}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.showPanelPJ) return null;

        const colors = {
            red: 'rgba(209, 4, 36, 0.7)',
            purple: '#b778c7',
            green: 'rgba(5, 134, 15, 0.6)',
            darkCyan: 'rgba(0,139,139,0.7)',
            orange: 'rgba(245, 170, 0, 0.8)',
            dimGray: 'rgba(105,105,105, 0.7)',
            blue: 'rgba(2, 17, 199, 0.5)',
            lightBlue: '#809AE0',
            bg: '#f8fafc'
        };

        return (
            <div style={{ padding: '40px 15px', backgroundColor: this.colors.bg, minHeight: '100vh' }}>
                <style>{`
                    .card-item-hover:hover {
                        background-color: #f1f5f9 !important;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
                    }
                `}</style>

                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    {/* Botão Voltar */}
                    <div 
                        onClick={this.goBack.bind(this)} 
                        style={{ cursor: 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontFamily: 'sans-serif', fontSize: '14px' }}
                    >
                        <FaStepBackward size={12} /> Voltar
                    </div>

                <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', color: '#334155', marginBottom: '25px' }}>
                    PAINEL DE GESTÃO PESSOA JURÍDICA (PJ)
                </div>

                <div className="grid-container">
                    {this.state.showPJawaitingPayment && this.renderMetricCard('AGUARDANDO CONFIRMAÇÃO', this.state.countPJawaitingPayment, urlBase.client + 'panel/companylist/pjawaitingpayment', colors.red, FaWallet)}
                    {this.state.showPJonActivation && this.renderMetricCard('PEJOTA EM ATIVAÇÃO', this.state.countPJonActivation, urlBase.client + 'panel/companylist/pjonactivation', colors.purple, FaCheckDouble)}
                    {this.state.showPJinValidation && this.renderMetricCard('EM VALIDAÇÃO', this.state.countPJinValidation, urlBase.client + 'panel/companylist/pjinvalidation', colors.darkCyan, FaSearch)}
                    {this.state.showPJafterSales && this.renderMetricCard('PÓS VENDA', this.state.countPJafterSales, urlBase.client + 'panel/companylist/pjaftersales', colors.lightBlue, FaHeadset)}
                    {this.state.showPJpending && this.renderMetricCard('PENDENTES', this.state.countPJpending, urlBase.client + 'panel/companylist/pjpending', colors.orange, FaExclamationCircle)}

                   {/*} {this.state.showPJactivated && this.renderMetricCard('PJ ATIVADAS', this.state.countPJactivated, urlBase.client + 'panel/companylist/pjactivated', colors.green, FaBuilding)} */}
                    {this.state.showPJdeployed60Days && this.renderMetricCard('IMPLANTADOS (60 DIAS)', this.state.countPJdeployed60Days, urlBase.client + 'panel/companylist/pjdeployed60days', colors.blue, FaHistory)}
                    {this.state.showPJcanceled60Days && this.renderMetricCard('CANCELADOS (60 DIAS)', this.state.countPJcanceled60Days, urlBase.client + 'panel/companylist/pjcanceled60days', colors.dimGray, FaTimesCircle)}
                </div>
            </div>
            </div>
        );
    }
}

export default PessoaJuridica;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/ResumeNew/PessoaJuridica.js
 **/